import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';
import './Hero.css';

export const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToWorks = () => {
    const worksSection = document.getElementById('works');
    if (worksSection) {
      worksSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-content-wrapper">
        <div className={`hero-content ${isVisible ? 'visible' : ''}`}>
          <div className="hero-text">
            <h1 className="hero-title">C. LLAGUNO</h1>
            <p className="hero-subtitle">{t('hero_subtitle')}</p>
            <p className="hero-tagline">{t('hero_tagline')}</p>
            
            <div className="hero-buttons">
              <Button 
                onClick={scrollToWorks}
                className="hero-cta primary"
              >
                {t('hero_cta_primary')}
              </Button>
              <Button 
                onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                className="hero-cta secondary"
              >
                {t('hero_cta_secondary')}
              </Button>
            </div>
          </div>
          
          <div className="hero-image-container">
            <img 
              src="https://customer-assets.emergentagent.com/job_studio-llaguno/artifacts/mgmdw4ey_WhatsApp%20Image%202026-05-28%20at%204.29.49%20PM.jpeg" 
              alt="C. Llaguno artwork"
              className="hero-image"
            />
          </div>
        </div>
      </div>

      <div className="shipping-banner" aria-hidden="true">
        <p>&nbsp;</p>
      </div>
    </section>
  );
};

export default Hero;
